
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bookings/map",
      function () {
        return require("private-next-pages/bookings/map.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bookings/map"])
      });
    }
  